/**
 * Minimal path constants needed before the full route table loads.
 * Keep in sync with navRoutes home entry in routes.js (id: NAV_MENU.Home.id).
 */
export const CONDITION_MANAGEMENT_PREFIX = '/condition-management';

/** Canonical path for primary home nav (WebsdkHomepage). */
export const HOME_PATH = '/home';
